import React, { useState } from 'react';
import { newsletterService } from '../../services/newsletterService';
import '../Auth/LoginModal.css';
import './WaitlistModal.css';

type WaitlistModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

function validateEmail(email: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

export const WaitlistModal: React.FC<WaitlistModalProps> = ({ isOpen, onClose }) => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState<{ text: string; type: 'success' | 'error' } | null>(null);
  const [emailError, setEmailError] = useState('');

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setEmail(value);
    setEmailError('');
    setMessage(null);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!email.trim()) {
      setEmailError('Введите email');
      return;
    }
    if (!validateEmail(email)) {
      setEmailError('Введите корректный email');
      return;
    }

    setIsLoading(true);
    setMessage(null);
    try {
      const result = await newsletterService.subscribe(email.trim());
      if (result.success) {
        setEmail('');
        setMessage({ text: result.message || 'Заявка принята. Мы свяжемся с вами.', type: 'success' });
      } else {
        setMessage({ text: result.message || 'Не удалось отправить заявку. Попробуйте еще раз.', type: 'error' });
      }
    } catch (err) {
      setMessage({ text: 'Что-то пошло не так, попробуйте еще раз', type: 'error' });
    } finally {
      setIsLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="auth-modal__overlay" onClick={onClose}>
      <div className="auth-modal__dialog waitlist-modal" onClick={(e) => e.stopPropagation()}>
        <div className="auth-modal__header">
          <h2 className="auth-modal__title">Заявка на вступление</h2>
          <button type="button" className="auth-modal__close" onClick={onClose} aria-label="Закрыть">
            ×
          </button>
        </div>

        <div className="auth-modal__body">
          <p className="waitlist-modal__subtitle">
            Закрытое сообщество для специалистов и руководителей инвестиционных компаний для конфиденциального обмена рыночными инсайтами.
          </p>

          <form onSubmit={handleSubmit} className="waitlist-modal__form">
            <div className="waitlist-modal__field">
              <label htmlFor="waitlist-email" className="waitlist-modal__label">
                Email
              </label>
              <input
                id="waitlist-email"
                type="email"
                value={email}
                onChange={handleEmailChange}
                placeholder="name@company.com"
                className={`waitlist-modal__input ${emailError ? 'error' : ''}`}
                disabled={isLoading}
                autoComplete="email"
              />
              {emailError && <div className="waitlist-modal__error">{emailError}</div>}
            </div>

            {message && (
              <div className={`waitlist-modal__message ${message.type}`}>
                {message.text}
              </div>
            )}

            <button type="submit" className="waitlist-modal__submit" disabled={isLoading}>
              {isLoading ? 'Отправляем…' : 'Оставить заявку'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

